<template>
  <div class='BuildIcon2'>
    <svg :fill="color" :width="tam" :height="tam" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>build</title>
      <path d="M28 12v16h-24v-12h4v-12h8v16h4v-4h4v-4h4z"></path>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'BuildIcon2',
  props: {
    tam: {
      type: String,
      default: '22px'
    },
    color: {
      type: String,
      default: '#000000'
    }
  }
}
</script>

<style scoped>
.BuildIcon2 {
}
</style>
